import { Platform } from 'react-native';
import AsyncStorage from '~global/storage';

const Config = require('~config/default.env').default;

const centralLoginUrl = Config.CENTRAL_LOGIN_WEB_URL;
const CentralAuth = {
  /**
   * Redirect to Central Login. When a path without its own query or fragment
   * is given, the current query string and fragment are carried over.
   * @param {string} path optional spesific path after login
   * @return {void}
   */
  login(path = '') {
    const hasOwnQuery = path.includes('?') || path.includes('#');
    const currentQuery = hasOwnQuery
      ? ''
      : `${window?.location?.search || ''}${window?.location?.hash || ''}`;
    const parentURL = window?.location?.origin + path + currentQuery;
    const currentURL = path ? parentURL : window?.location?.href;

    let redirectURL = centralLoginUrl;
    if (currentURL) {
      redirectURL += `?callback_url=${encodeURIComponent(currentURL)}`;
    }
    window.location.href = redirectURL;
  },
  logout() {
    const currentURL = window?.location?.href || '';
    let redirectURL = centralLoginUrl + '/api/redirect/';
    const callbackURL =
      window.location.pathname === '/page/settings'
        ? window.location.origin
        : currentURL;
    // goto lilla.id when logout from settings page
    if (currentURL) {
      redirectURL += `?callback_url=${encodeURIComponent(callbackURL)}`;
    }
    // Ensure to clear user data before redirecting to Central Login
    AsyncStorage.removeItem('userData');
    window.location.href = redirectURL;
  },
};

// pages the central login's Legal Statements popup opens, marked with ?from=central-login (NON-15667)
const CENTRAL_LOGIN_LEGAL_PAGES = ['/termsandconditions', '/privacypolicy'];

/**
 * Tells whether this page is a Terms & Conditions or Privacy Policy page opened from the central login,
 * read from the address bar because the router may not have resolved the first route yet.
 * @return {boolean} True on a marked legal page of the web build.
 */
function isCentralLoginLegalPage() {
  if (
    Platform.OS !== 'web' ||
    typeof window === 'undefined' ||
    !window.location
  ) {
    return false;
  }
  const path = window.location.pathname.replace(/\/+$/, '');
  const params = new URLSearchParams(window.location.search);
  return (
    CENTRAL_LOGIN_LEGAL_PAGES.includes(path) &&
    params.get('from') === 'central-login'
  );
}

/**
 * Stops a request from sending the shared login cookie on a legal page opened from the central login.
 * While a registration is unfinished that cookie holds its token, and our APIs sign the registration
 * out when the token comes from another site, which would lose the form the customer is filling in.
 * @param {object} config - Axios request config.
 * @return {object} The config, without credentials on a marked legal page.
 */
export function dropCredentialsOnCentralLoginLegalPage(config) {
  if (isCentralLoginLegalPage()) {
    config.withCredentials = false;
  }
  return config;
}

export default CentralAuth;
